import { gql } from "@apollo/client";

export const CONNECTORS = gql`
  query Connectors($category: String) {
    connectors(category: $category) {
      key
      category
      label
      vendor
      direction
      selection
      serviceFile
      inbound
      configKeys
      status
      configured
      enabled
      hasCredentials
      envConfigured
      presentConfigKeys
      missingConfigKeys
      integrationId
      config
      inputs {
        name
        label
        required
        aliases
        hint
      }
      outputs {
        name
        label
        hint
      }
      operations {
        key
        label
        inputs {
          name
          label
          required
          aliases
          hint
        }
        outputs {
          name
          label
          hint
        }
      }
    }
  }
`;

const connectors = { CONNECTORS };

export default connectors;

export const TRACKING_CONFIG = gql`
  query TrackingConfig {
    trackingConfig {
      googleAdsId
      gtmContainerId
    }
  }
`;
